<template>
    <v-row no-gutters>
        <v-col cols="5">
            <div class="position-relative">
                <v-img :src="productImageSrc(orderItem.product)"
                       class="flex-grow-0"
                       aspect-ratio="1"></v-img>
                <div class="badge body-1 font-weight-bold" :class="`badge--${orderItem.status}`">
                    {{ $vuetify.lang.t(`$vuetify.widgets.orders.${orderItem.status}`) }}
                </div>
            </div>
            <router-link :to="{ name: route, params: { orderItemId: orderItem.id }}" class="d-block mt-2 body-1 text-decoration-none">
                {{ $vuetify.lang.t('$vuetify.buttons.further_inquiries') }}
            </router-link>
        </v-col>
        <v-col class="pl-3">
            <div class="py-0 body-1 text-uppercase">
                {{ orderItem.product.product_brand }}
            </div>
            <div class="pt-0 font-weight-bold headline">
                {{ orderItem.product.title }}
            </div>

            <!-- expandable -->
            <template v-if="expandable">
                <v-expand-transition>
                    <div v-if="accordion">
                        <div class="py-0 body-1 pt-2">
                            {{ orderItem.quantity }}x{{ orderItem.price | number }} {{ $vuetify.lang.t('$vuetify.points.long') }}
                        </div>
                        <div class="pt-0 font-weight-bold headline">
                            {{ orderItem.quantity * orderItem.price | number }} {{ $vuetify.lang.t('$vuetify.points.long') }}
                        </div>
                    </div>
                </v-expand-transition>
                <div class="pt-0 body-1 font-weight-bold pt-2">
                    {{ $vuetify.lang.t('$vuetify.widgets.orders.order') }}:
                </div>
                <div class="body-1">
                    {{ $vuetify.lang.t('$vuetify.widgets.orders.order_title_short', orderItem.order.order_number,
                    $options.filters.date(orderItem.order.created_at)) }}
                </div>
                <v-expand-transition>
                    <div v-if="accordion">
                        <div class="pt-0 body-1 font-weight-bold pt-2">
                            {{ $vuetify.lang.t('$vuetify.widgets.orders.address') }}:
                        </div>
                        <div class="body-1">

                            {{ orderItem.order.delivery_address.delivery_address_firstname }}
                            {{ orderItem.order.delivery_address.delivery_address_lastname }}<br>
                            <template v-if="orderItem.order.delivery_address.delivery_address_company">
                                {{ orderItem.order.delivery_address.delivery_address_company }}<br>
                            </template>
                            {{ orderItem.order.delivery_address.delivery_address_street }}
                            {{ orderItem.order.delivery_address.delivery_address_number }},
                            {{ orderItem.order.delivery_address.delivery_address_zip }}
                            {{ orderItem.order.delivery_address.delivery_address_city }}
                        </div>
                    </div>
                </v-expand-transition>
            </template>
            <!-- /expandable -->
            <template v-else>
                <div class="py-0 body-1 pt-2">
                    {{ orderItem.quantity }}x{{ orderItem.price | number }} {{ $vuetify.lang.t('$vuetify.points.long') }}
                </div>
                <div class="pt-0 font-weight-bold headline">
                    {{ orderItem.quantity * orderItem.price | number }} {{ $vuetify.lang.t('$vuetify.points.long') }}
                </div>
            </template>

            <template v-if="!expandable && orderItem.delivery_date">
                <div class="pt-2 body-1 font-weight-bold">
                    {{ $vuetify.lang.t('$vuetify.widgets.orders.possible_delivery') }}:
                </div>
                <div class="body-1">
                    {{ orderItem.delivery_date | date }}
                </div>
            </template>

            <template v-if="orderItem.delivery_service && orderItem.tracking_id && !expandable">
                <div class="pt-2 body-1 font-weight-bold">
                    {{ $vuetify.lang.t('$vuetify.widgets.orders.shipping_info') }}:
                </div>
                <div class="body-1">
                    {{ orderItem.delivery_service }}, {{ orderItem.tracking_id }}
                </div>
            </template>
        </v-col>
        <v-col cols="auto" v-if="expandable">
            <v-icon v-if="!accordion" @click="accordion = !accordion">mdi-chevron-down</v-icon>
            <v-icon v-else @click="accordion = !accordion">mdi-chevron-up</v-icon>
        </v-col>
    </v-row>
</template>
<script>
    import { ROUTE_ORDER_DETAILS } from '../utils/constants';

    export default {
        name: 'order-item',
        props: {
            orderItem: {},
            expandable: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                accordion: false,
            }
        },
        computed: {
            route() {
                return ROUTE_ORDER_DETAILS;
            },
        },
        methods: {
            productImageSrc(product) {
                return product.images.length > 0 ? product.images[0].source : '//via.placeholder.com/150x150/a1a1a1/FF0000/?text=Fallback';
            },
        }
    }
</script>
